import { LiveDemo } from './LiveDemo.js';

/**
 * The stage half of the auth split — what a visitor gets an account *for*.
 *
 * It argues by demonstration rather than description: the panel is a big
 * screen, rendered with the same CodeCells, lamp and ResultBars the real one
 * uses, with votes landing on it. Nothing here is a marketing mock-up of the
 * product; it is the product's own components fed fixture counts, which is
 * also why the tungsten lamp is allowed to be lit (see the Gallery precedent).
 *
 * The whole demo is aria-hidden (see LiveDemo). The cue sheet beside it
 * carries the same claims in words, and stays exposed.
 */
export function AuthShowcase() {
  return (
    <aside className="stage-panel">
      <div className="stage-inner">
        <p className="eyebrow">Live polls for the room in front of you</p>
        <h2 className="stage-headline">Ask the room. Watch it answer.</h2>

        <LiveDemo size="md" />

        <ul className="stage-cues">
          <li className="stage-cue">
            <p className="eyebrow">Build it</p>
            <p className="stage-cue-line">
              Questions grouped into screens, in your colors, with your logo.
            </p>
          </li>
          <li className="stage-cue">
            <p className="eyebrow">Open the room</p>
            <p className="stage-cue-line">
              Six characters on the big screen. Your audience needs no app and no account.
            </p>
          </li>
          <li className="stage-cue">
            <p className="eyebrow">Watch it land</p>
            <p className="stage-cue-line">
              Every vote reaches the screen in under two seconds. Nothing to refresh.
            </p>
          </li>
        </ul>

        <p className="stage-note">
          Results stay on the poll between presentations, and one workspace holds your whole team.
        </p>
      </div>
    </aside>
  );
}
